import { render, staticRenderFns } from "./build_by_oneself.vue?vue&type=template&id=4ddf61f3&scoped=true"
import script from "./build_by_oneself.vue?vue&type=script&lang=js"
export * from "./build_by_oneself.vue?vue&type=script&lang=js"
import style0 from "./build_by_oneself.vue?vue&type=style&index=0&id=4ddf61f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddf61f3",
  null
  
)

export default component.exports